import { useQuery } from '@tanstack/react-query';
import { api } from 'constants/api';
import { ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type CreditsResponseType = {
  credits: number;
};

export const useGetCredits = (
  options: QueryOptions<CreditsResponseType> = {}
) =>
  useQuery({
    queryFn: async (): Promise<CreditsResponseType> => {
      const { data } = await api.get<ApiResponse<CreditsResponseType>>(
        `/purchase/current-credits`
      );

      return data.data;
    },
    queryKey: ['purchase/current-credits'],
    ...options,
  });
